import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ColumnChooser from '../../../../components/ColumnChooser';
import ExcelExportMenu from '../../../../components/ExcelExportMenu';
import { ExcelExportMode } from '../../../../helpers/excelExportRequest';
import { ColumnChooserModel } from '../../../../models/common/ColumnChooserModel';
import { GetCurrencyConversionListPagingAndFilterRequest } from '../../../../models/request/currencyConversion/GetCurrencyConversionListPagingAndFilterRequest';
import { RootState } from '../../../../redux/store';
import { MenuComponent } from '../../../../_metronic/assets/ts/components';
import TableConstantActions from '../../../../components/TableConstantActions';

interface Props {
    columns: ColumnChooserModel[]
    setColumns: React.Dispatch<React.SetStateAction<ColumnChooserModel[]>>
    getColumns: () => ColumnChooserModel[]
    pageName: string
    pageVersion: string
    excelExport: (mode: ExcelExportMode) => void
    filter: GetCurrencyConversionListPagingAndFilterRequest
    setFilter: React.Dispatch<React.SetStateAction<GetCurrencyConversionListPagingAndFilterRequest>>
    selectedCount: number
    deleteFunction: () => void
    updateFunction: () => void
    onSearchSubmit: (e: any) => void
}

const CurrencyConversionListFilters = ({
    columns,
    setColumns,
    getColumns,
    pageName,
    pageVersion,
    excelExport,
    filter,
    setFilter,
    selectedCount,
    deleteFunction,
    updateFunction,
    onSearchSubmit
}: Props) => {
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.auth)

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    return (
        <React.Fragment>
            {/* Güncelle / Sil düğmeleri üst şeritte (standart). Arama kutusu gizli: arama
                hiç çalışmıyordu, yerine kolon başlığının altındaki filtreler var. */}
            <TableConstantActions
                deleteFunction={deleteFunction}
                onSearchSubmit={onSearchSubmit}
                pageName={pageName}
                hideSearch={true}
                searchTerm={filter.searchTerm}
                selectedCount={selectedCount}
                setSearchTerm={(e) => setFilter({ ...filter, searchTerm: e })}
                updateFunction={updateFunction}
            />

            <ColumnChooser
                columns={columns}
                getColumns={getColumns}
                pageName={pageName}
                pageVersion={pageVersion}
                setColumns={setColumns}
            />

            <ExcelExportMenu
                pageName={pageName}
                selectedCount={selectedCount}
                onExport={excelExport}
            />

            <React.Fragment>
                {
                    auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canInsert && (
                        <div className='m-0'>
                            <a
                                onClick={() => navigate('/currencyconversion/listadd')}
                                className='btn btn-sm fw-bold btn-primary'
                            >
                                Yeni Döviz Kuru Ekle
                            </a>
                        </div>
                    )
                }
            </React.Fragment>
        </React.Fragment>
    )
}

export default CurrencyConversionListFilters;